<script>
    import { Doughnut } from 'vue-chartjs'

    export default {
        extends: Doughnut,
        props: {
            chartdata: Array,
            options: Array,
            dataname: String,
            dncolor: Array,
            chartOptions: {
                default: () => ({
                    showAllTooltips: false
                })
            },
            displayLabels: Boolean
        },
        mounted () {
            Chart.defaults.global.legend.display = true

            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: this.dncolor,
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels,
                        },
                    }
                ]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                showAllTooltips: this.chartOptions.showAllTooltips,
            })
        }
    }
</script>

<style scoped>



</style>
